<script setup>
import { mdiCamera } from '@mdi/js'
import FileInput from '@/components/inputs/FileInput.vue'

const emit = defineEmits(['update'])

const updateImage = async (f) => {
	if (!f) {
		return
	}

	try {
		emit('update', { url: await fileToUrl(f) })
	} catch (e) {
		console.error(e.message)
	}
}

/**
 * Takes a file or blob and returns a Base64-encoded string representation
 * @param {File|Blob} file 
 */
const fileToUrl = async (file) => {
	let resolve, reject
	const promise = new Promise((res, rej) => {
		resolve = res
		reject = rej
	})

	const reader = new FileReader()
	reader.onload = () => resolve(reader.result)
	reader.onerror = reject
	reader.readAsDataURL(file)

	return await promise
}
</script>

<template>
<FileInput
	v-bind="$attrs"
	:append-icon="mdiCamera"
	accept="image/*"
	capture="camera"
	style="width: calc(100% - 32px);"
	@update:model-value="updateImage"
>
	<slot>Take Picture</slot>
</FileInput>
</template>

<style lang="scss" scoped>

</style>